// VAT (Value Added Tax) standard rates by country, keyed by ISO 3166-1
// alpha-2 code.
//
// Mirrors the root-level vat-rates.js (used by the BE VIN-queue processing)
// so the UI's country dropdown offers the same rates. Kept as a separate
// copy because CRA (react-scripts) forbids importing files from outside the
// src/ directory.
export const VAT_RATES = {
    AL: { country: 'Albania', vatRate: 20 },
    AD: { country: 'Andorra', vatRate: 4.5 },
    AT: { country: 'Austria', vatRate: 20 },
    BY: { country: 'Belarus', vatRate: 20 },
    BE: { country: 'Belgium', vatRate: 21 },
    BA: { country: 'Bosnia and Herzegovina', vatRate: 17 },
    BG: { country: 'Bulgaria', vatRate: 20 },
    HR: { country: 'Croatia', vatRate: 25 },
    CY: { country: 'Cyprus', vatRate: 19 },
    CZ: { country: 'Czech Republic', vatRate: 21 },
    DK: { country: 'Denmark', vatRate: 25 },
    EE: { country: 'Estonia', vatRate: 24 },
    FI: { country: 'Finland', vatRate: 25.5 },
    FR: { country: 'France', vatRate: 20 },
    DE: { country: 'Germany', vatRate: 19 },
    GR: { country: 'Greece', vatRate: 24 },
    HU: { country: 'Hungary', vatRate: 27 },
    IS: { country: 'Iceland', vatRate: 24 },
    IE: { country: 'Ireland', vatRate: 23 },
    IT: { country: 'Italy', vatRate: 22 },
    XK: { country: 'Kosovo', vatRate: 18 },
    LV: { country: 'Latvia', vatRate: 21 },
    LI: { country: 'Liechtenstein', vatRate: 8.1 },
    LT: { country: 'Lithuania', vatRate: 21 },
    LU: { country: 'Luxembourg', vatRate: 17 },
    MT: { country: 'Malta', vatRate: 18 },
    MD: { country: 'Moldova', vatRate: 20 },
    ME: { country: 'Montenegro', vatRate: 21 },
    NL: { country: 'Netherlands', vatRate: 21 },
    MK: { country: 'North Macedonia', vatRate: 18 },
    NO: { country: 'Norway', vatRate: 25 },
    PL: { country: 'Poland', vatRate: 23 },
    PT: { country: 'Portugal', vatRate: 23 },
    RO: { country: 'Romania', vatRate: 19 },
    RS: { country: 'Serbia', vatRate: 20 },
    SK: { country: 'Slovakia', vatRate: 23 },
    SI: { country: 'Slovenia', vatRate: 22 },
    ES: { country: 'Spain', vatRate: 21 },
    SE: { country: 'Sweden', vatRate: 25 },
    CH: { country: 'Switzerland', vatRate: 8.1 },
    UA: { country: 'Ukraine', vatRate: 20 },
    GB: { country: 'United Kingdom', vatRate: 20 }
};

// Dropdown-ready list, sorted by country name.
export const VAT_COUNTRY_OPTIONS = Object.entries(VAT_RATES)
    .map(([code, { country, vatRate }]) => ({ label: `${country} (${vatRate}%)`, value: code, vatRate }))
    .sort((a, b) => a.label.localeCompare(b.label));
